import Hide from './src/hide-combined';
export default Hide;